import { z } from 'zod';

import { ZodB2bSavingPlanCategory, ZodB2bSavingPlanType } from '@Common/types/b2b/plans';
import { zodIntegerAmount2 } from '@Common/types/currency/currency';
import { ZodProfileSavingPlanId } from '@Common/types/profile/saving_plans';
import { ZodIDPathParam, ZodId } from '@Common/types/request';
import { endpoint, GetEndpointType } from '@Common/types/zod/zod-endpoint';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodB2BWithdrawFrom = ZodB2bSavingPlanCategory.or(z.literal('early'));
export type B2BWithdrawFrom = z.infer<typeof ZodB2BWithdrawFrom>;

const ZodPositionData = z.object({
  instrument_id: ZodId,
  amount: zodIntegerAmount2,
  short_name: ZodTrimmedString.nullable(),
  symbol: ZodTrimmedString,
});

const ZodPlanData = z.object({
  plan_id: ZodProfileSavingPlanId,
  type: ZodB2bSavingPlanType,
  category: ZodB2bSavingPlanCategory,
  withdrawable: zodIntegerAmount2,
  locked: zodIntegerAmount2,
  total: zodIntegerAmount2,
  withdrawable_positions: ZodPositionData.array(),
  locked_positions: ZodPositionData.array(),
});

const ZodGetEmployeeLockedFundsResponse = z.object({
  id: ZodId,
  withdrawable: zodIntegerAmount2,
  locked: zodIntegerAmount2,
  total: zodIntegerAmount2,
  plans: ZodPlanData.array(),
  suspended: zodIntegerAmount2,
  suspended_positions: ZodPositionData.array(),
  categories: z.array(
    z.object({
      type: ZodB2bSavingPlanCategory,
      withdrawable: zodIntegerAmount2,
      locked: zodIntegerAmount2,
      total: zodIntegerAmount2,
    }),
  ),
});
export type GetEmployeeLockedFundsResponse = z.TypeOf<typeof ZodGetEmployeeLockedFundsResponse>;

export const getB2bEmployeesLockedFundsIdEndpoint = endpoint({
  method: 'GET',
  pathParams: ZodIDPathParam,
  responseBody: ZodGetEmployeeLockedFundsResponse,
});

export type GetB2bEmployeesLockedFundsIdEndpoint = GetEndpointType<
  typeof getB2bEmployeesLockedFundsIdEndpoint
>;
